module.exports = __webpack_public_path__ + "img/IncubatorAccelerator.3f809618.svg";